var flag = 0;
$(document).ready(function(){
  updateYnet(); 
  setInterval(updateYnet,900000);
  function updateYnet(){ 
    $.get( "ynetnews.php", function( data ) {
      if(flag == 1){
        $('.ticker-wrap').slick('unslick');
      }
      $( ".ticker-wrap" ).html( data );
      $('.ticker-wrap').slick({
        speed: 9000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        rtl: true
      });
      flag = 1;
    });
  }

  setInterval(function(){
    $.get( "forceupdate.html", function( data ) {
      if(data.trim() == 'reload'){
        console.log(data.trim());
        window.location.reload();
      }
    });
  },3000);

});
